const collaboratorsMenu: any = {
  id: "collaborators",
  parent_id: "manage-users",
  title: "Collaboratori",
  translate: "MENU.COLLABORATOR_USERS_LIST",
  type: "collapsible",
  icon: "user",
  capability: "show_menu_collaborator_list",
  children: [
    {
      id: "users-collaborator-list",
      title: "Lista",
      translate: "LIST",
      type: "item",
      capability: "show_menu_collaborator_list",
      url: "dashboard/collaborators/list",
    },
    {
      id: "transformation",
      title: "Trasformazioni",
      translate: "MENU.TRANSFORMATION",
      type: "item",
      capability: "show_menu_transformation",
      url: "dashboard/transformation-list",
    },
    {
      id: "collaborators-costs",
      title: "Costi",
      translate: "COSTS",
      type: "item",
      capability: "show_menu_collaborator_costs",
      url: "dashboard/collaborator/costs",
    },
  ],
  order: 7,
};

export default collaboratorsMenu;
